/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_Q2Inputs */

const en_guide_large_json_files_faq_q2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does minification really help with large files?`)
};

const ko_guide_large_json_files_faq_q2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축이 대용량 파일에 정말 도움이 되나요?`)
};

const ja_guide_large_json_files_faq_q2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮は大きなファイルに本当に効果がありますか？`)
};

/**
* | output |
* | --- |
* | "Does minification really help with large files?" |
*
* @param {Guide_Large_Json_Files_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_q2 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_q2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_q2(inputs)
	return ja_guide_large_json_files_faq_q2(inputs)
});